import { render, staticRenderFns } from "./PageNavigation.vue?vue&type=template&id=bbf40988&scoped=true&lang=html&"
import script from "./PageNavigation.vue?vue&type=script&lang=ts&"
export * from "./PageNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./PageNavigation.vue?vue&type=style&index=0&id=bbf40988&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf40988",
  null
  
)

export default component.exports